import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/member-todo-timeline-box';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-member-todo-timeline-box', {
  mixins: [eventListenerMixin],

  properties: {
    headerNavItemSelector: String,

    currentPage: {
      type: Number,
      default: 1,
    },

    scrollLoadUrl: String,
  },

  connected() {
    this.initScroller();

    if (this.headerNavItemSelector) {
      this.headerNavItem = document.querySelector(this.headerNavItemSelector);
      if (this.headerNavItem) this.headerNavItem.classList.add('active');
    }
  },

  initScroller() {
    window.tower.scrollLoad(this, () => $.ajax({
      url: this.scrollLoadUrl,
      type: 'GET',
      dataType: 'html',
      data: {
        page: this.currentPage + 1,
        last_todo_guid: $('.todolist tr-todo-item-plus:last').attr('guid'),
      },
      success: (result) => {
        if (result) {
          this.insertTodos($(result));
          this.currentPage += 1;
        }
      },
    }));
  },

  insertTodos(nodes) {
    const emptyMsg = document.querySelector('.empty-message');
    const lastBlockInPage = $(this).find('.day').last();
    const firstBlockInResult = nodes.first();

    if (lastBlockInPage.data('date') !== firstBlockInResult.data('date')) {
      $(emptyMsg).before(nodes);
    } else {
      const leftNodes = nodes.slice(1);
      lastBlockInPage.find('.todolist').append(firstBlockInResult.find('.todolist').contents());
      $(emptyMsg).before(leftNodes);
    }
  },

  removeItem(todoGuid) {
    const todoItem = this.querySelector(`tr-todo-item-plus[guid="${todoGuid}"]`);
    const dateItem = closest(todoItem, '.day');
    const selector = `tr-todo-item-plus:not([guid="${todoGuid}"])`;
    const leftTodos = $(closest(todoItem, '.todolist')).find(selector).length;
    if (leftTodos === 0) {
      dateItem.parentNode.removeChild(dateItem);
    } else {
      todoItem.parentNode.removeChild(todoItem);
    }
  },

  diconnected() {
    if (this.headerNavItem) this.headerNavItem.classList.remove('active');
  },
});
